import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Heading from '@legacy-vfuk/core-heading';
import Icon from '@legacy-vfuk/core-icon';
import { CardWithIconsAndTextProps } from './types/Card.types';
import {
  iconTextStyle,
  textBlock,
  imageBlock,
  ContainerWrapper,
  IconTextContent,
} from './styles/CardWithIconsAndText.styles';
import { Container } from '@legacy-vfuk/core-container';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';

const CardWithIconAndText = ({ data }: CardWithIconsAndTextProps) => {
  const {
    name,
    mainImage,
    redLink,
    iconsAndText = [],
  } = data;

  const iconTextRow = iconsAndText?.map(icon => {
    return (
      <div key={icon.id} css={iconTextStyle} style={{ color: icon.color }}>
        <Icon
          name={icon.iconRef}
          size={icon.iconSize}
          appearance={icon.appearance || 'primary'}
          inverse={icon.inverse}
        />
        <IconTextContent>{icon.label}</IconTextContent>
      </div>
    );
  });

  const handleCardClick = () => {
    if (redLink) {
      fireButtonAndLinkClicksEvent({
        event_label: redLink.name,
        event_action: 'link click',
      });
      if (typeof window !== 'undefined') {
        if (window.innerWidth < 641) {
          window.location.href = redLink.url;
        }
      }
    }
  };

  return (
    <ContainerWrapper>
      <Container elevation onClick={redLink ? handleCardClick : undefined}>
        {mainImage && (
          <GatsbyImage
            image={getImage(mainImage) as IGatsbyImageData}
            css={imageBlock}
            alt={mainImage.description}
          />
        )}
        <div css={textBlock}>
          <Heading text={name} weight={3} size={2} />
        </div>
        <div>{iconsAndText?.length > 0 && iconTextRow}</div>
      </Container>
    </ContainerWrapper>
  );
};

export default CardWithIconAndText;
